//extracted by mini-css-extract-plugin
export default {"main":"EEOComp_main__81TPO","EEOImg":"EEOComp_EEOImg__OROb3","container":"EEOComp_container__OkVqJ","title":"EEOComp_title__wzZ-u","blueHead":"EEOComp_blueHead__nyIyo"};;